Controller = App.loadClass 'core::Angular/Controller'

class exports.SidebarController extends Controller
    constructor: (
        @scope
        @transitions
        @state
        @machinery
        @RxOptions
        @rxLayer
        @map
        @layerManager
        @truthStripToolbar
        @loader
    ) ->
        @rxLayer.reset()

        @preload_on_state_change = false
        super(@scope, @transitions)

        @scope.rx = @rxLayer.data
        @scope.spp = @RxOptions.retrieve('spp')
        @scope.is_from_spp = @RxOptions.exists('spp')
        @scope.referer = @RxOptions.retrieve('from_state')
        @scope.pp_planter = @RxOptions.retrieve('planter')
        @scope.aborted = false
        @scope.is_valid = false
        @scope.show_fullpage = true
        @scope.gotoStep = @gotoStep
        @scope.gotoNextStep = @gotoNextStep
        @scope.gotoPrevStep = @gotoPrevStep
        @scope.exitProcess = @exitProcess
        @scope.setValidity = @setValidity
        @scope.save = @save

        @scope.$on '$destroy', () =>
            @loader.hideAll()

        if @state.params.id?
            @RxOptions.store 'id', @state.params.id
            @scope.rx.id = @state.params.id

        if not @scope.rx.id? and not @RxOptions.retrieve('spp_id')?
            @scope.aborted = true
            @exitProcess()
            return

        if @scope.is_from_spp then @scope.btnText = 'Fit Seed to Field' else @scope.btnText = 'Cancel'

        @scope.averagePop = @rxLayer.averagePop
        @scope.steps = [
            {
                name: 'Product Planter'
                state: 'grower.planting-rx.products'
                fullpage: true
            }
            { name: 'Layers', state: 'grower.planting-rx.layers' }
            # disabled for https://www.pivotaltracker.com/story/show/176890260
            # { name: 'Truth Strip', state: 'grower.planting-rx.truth-strips' }
            {
                name: 'Prescription Map'
                state: 'grower.planting-rx.prescription'
                wide: true
                showNameOnButton: true
            }
        ]

        @scope.repos = {
            seed_companies: null
            brands: null
            treatments: null
            planters: null
        }

        # Fetch the grower's planters
        @machinery.planters(@scope.spp?.cropID).then (response) =>
            @scope.repos.planters = response.data.data

            # Preload the planter used in the converted plan if it's variable rate
            if @scope.is_from_spp and @scope.pp_planter isnt null
                for planter in @scope.repos.planters
                    @scope.rx.planter = planter if planter.id is @scope.pp_planter


        # Whenever a step is loading, show the preloader
        @scope.$on 'planting-rx:step-loading', () =>
            @load_msg = @loader.overMapAndSidebar 'Loading...'

        # Whenever a step is done loading, hide the preloader
        @scope.$on 'planting-rx:step-ready', () =>
            @load_msg.hide()


        # IMPORTANT! Okay, so, even when doing a brand new shiny
        # layer, we post to the backend to get the data structure.
        # This is because the SPP likes to fiddly with things (preselect
        # hybrids, etc). SO! we don't go to the first step until after
        # we've populated the data.
        @rxLayer.loadFromStorage(@RxOptions).then (response) =>
            @scope.rx.previous_visual_layers = _.clone @scope.rx.visual_layers
            @scope.rx.previous_calculation = @rxLayer.asSolverOptions()
            @scope.show_preloader = false

            # If there's no fields ID, that means we got to this page directly,
            # not via an SPP or viewing a save Rx, so we should bail out.
            if not @scope.rx.fields_id
                @exitProcess()
                return

            @setUpMap()

            if _.endsWith(@state.current.name, 'planting-rx')
                @gotoStep(@scope.steps[0])
            else
                step = @scope.steps.filter((step) =>
                    return @state.is(step.state)
                )[0]
                @gotoStep(step) if step?
            @scope.$broadcast 'rx:loaded'


    ###
     * Since each Step itself decides validity, we need a way for
     * the child steps to tell us if they are valid. Obviously, we could
     * let them directly play with our is_valid scope variable, but a
     * method feels nicer, and seems more flexible for if we change
     * away from relying on the $parent scope relationship for this.
    ###
    setValidity: (value) =>
        @scope.is_valid = value


    ###
     * Initializes some stuff we need for the map portions of this process
    ###
    setUpMap: () ->
        # Feature group to wrap up everything that goes on the
        # map during this process.
        @mapLayer = @map.createFeatureGroup()

        # We add this to the map with the name "field-boundary"
        # so we can pull it up elsewhere if we need to.
        @map.add(@mapLayer, null, 'field-boundary')

        @layerManager.get('Field').display(
            { id: @scope.rx.fields_id },
            @mapLayer,
            { color: '#00FF00', fillOpacity: 0.0 }
        ).then () =>
            @map.centerOn(@mapLayer)
            @truthStripToolbar.reset()

        # When the scope for this controller is destroyed (meaning
        # that the controller is destroyed), remove the map layer
        # so that any map stuff we've done will not get stuck on the
        # map after leaving the process
        @scope.$on '$destroy', () =>
            @map.remove(@mapLayer)


    # Yay, you made it through the Rx process, and now you want to save an rx layer!
    save: () =>
        save_msg = @loader.overMapAndSidebar 'Saving Prescription...'
        @rxLayer.save().then (resp) =>
            save_msg.hide()
            if resp.data?.status?.type is 'success'
                exit_data = $.extend {}, resp.data.data
                exit_data.hybrids = @rxLayer.getHybrids()
                @exitProcess exit_data


    # Exits the truth strip process. If we have access to the SPP (we always
    # will right now, until editing support happens), send us back there
    exitProcess: (exit_data) =>
        if @RxOptions.exists('spp')
            @RxOptions.retrieve('spp').dialog.show()

            $(window).trigger('rx:completed', exit_data) if exit_data

        if @scope.referer
            @state.go(@scope.referer)
        else
            @state.go('grower.data')



    # Goes to the next step in the @scope.steps list
    gotoNextStep: () =>
        next = @_findStepIndex(@scope.activeStep.name) + 1
        @scope.$broadcast('rx:steps-next') # Event so steps know which way we're going
        @gotoStep(@scope.steps[next])


    # Goes to the previous step in the @scope.steps list
    gotoPrevStep: () =>
        prev = @_findStepIndex(@scope.activeStep.name) - 1

        if prev < 0
            @exitProcess()
        else
            @scope.$broadcast('rx:steps-prev') # Event so steps know which way we're going
            @gotoStep(@scope.steps[prev])


    # Given a step's name, returns the index in the @scope.steps array
    _findStepIndex: (name) =>
        for step, ind in @scope.steps
            if step.name is name
                return ind
                break

    # Activate a given step. Takes the step object as it's parameter
    gotoStep: (step) =>
        if @scope.activeStep?
            @scope.activeStep.active = false

        @scope.activeStep = step
        step.active = true
        step.visited = true

        @state.go(step.state, null, location: false)
        if step.fullpage
            @scope.show_fullpage = true
        else
            @scope.show_fullpage = false
